import PropTypes from 'prop-types';
import React from 'react';
import {useHistory} from 'react-router-dom';
import {useQuery} from '@apollo/client';

import Table from '@appComponents/Table';
import {GetMappedIsoCodes} from '@graphql/country/query';
// eslint-disable-next-line import/no-named-as-default
import routes from '@constants/routes';
import {columns} from '@modules/events/components/EventGeoRestrictions/eventGeoRestrictionColumns';
import {rowRenderer} from '@modules/events/components/EventGeoRestrictions/eventGeoRestrictionRowRenderer';

const EventGeoRestrictionTable = (props) => {
    const history = useHistory();
    const {eventGeoRestrictions, eventId, loading} = props;
    const {data, loading: queryLoading} = useQuery(GetMappedIsoCodes);

    const preparedRowRenderer = (column, row) => {
        return rowRenderer(column, row, data, eventId, history);
    };

    return (
        <div className='event_geo_restriction__table'>
            <Table
                url={routes.events.geoRestrictions.index.path}
                columns={columns}
                data={eventGeoRestrictions}
                loading={loading || queryLoading}
                name='eventGeoRestrictionsList'
                noDataText='No geo restrictions found'
                pagination={false}
                rowRenderer={preparedRowRenderer}
            />
        </div>
    );
};

EventGeoRestrictionTable.propTypes = {
    data: PropTypes.shape({
        mappedIsoCodes: PropTypes.shape({
            countries: PropTypes.object,
            subdivisions: PropTypes.object,
        }),
    }),
    eventGeoRestrictions: PropTypes.array,
    eventId: PropTypes.number.isRequired,
    loading: PropTypes.bool,
};
EventGeoRestrictionTable.defaultProps = {
    data: {
        mappedIsoCodes: {
            countries: {},
            subdivisions: {},
        },
    },
    eventGeoRestrictions: [],
    loading: false,
};
EventGeoRestrictionTable.displayName = 'EventGeoRestrictionTable';

export default EventGeoRestrictionTable;
